<template>
  <div class="p-2">
    <div class="flex gap-4 overflow-scroll p-3 no-scrollbar snap-x" ref="test">
      <MonthViewer
        v-for="month in 12"
        :key="month"
        :month="month"
        :active="month === selectedMonth"
        @monthClicked="
          selectedMonth = $event;
          selectedDay = '';
        "
      />
    </div>

    <div class="flex gap-4 overflow-scroll no-scrollbar snap-x py-2">
      <DayViewer
        v-for="day in daysInMonth"
        :key="day"
        :day="day"
        :month="selectedMonth"
        :active="day === selectedDay"
        @dayClicked="selectedDay = $event"
      />
    </div>

    <!-- Numbers Box -->
    <div
      class="relative flex justify-between bg-gray-900 rounded-lg mt-3 p-4 overflow-hidden"
    >
      <div>
        <UsersIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ summaryData.customerCount }} نفر
        </h6>
        <span class="text-gray-400 text-xs">مهمان ها</span>
      </div>
      <div>
        <CashIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">
          {{ $helper.numberShortener(summaryData.mab) }} تومان
        </h6>
        <span class="text-gray-400 text-xs">فروش</span>
      </div>
      <div>
        <ReceiptTaxIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">{{ summaryData.ticketQty }} عدد</h6>
        <span class="text-gray-400 text-xs">فاکتورها</span>
      </div>
      <div>
        <FireIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">{{ summaryData.kalaQty }} پرس</h6>
        <span class="text-gray-400 text-xs">غذاها</span>
      </div>
      <div>
        <UsersIcon class="h-6 w-6 text-red-500" />
        <h6 class="text-white text-sm mt-2">{{ countSalon }} نفر</h6>
        <span class="text-gray-400 text-xs">تالار</span>
      </div>

      <div
        class="absolute flex items-center justify-center bg-gray-900/80 left-0 right-0 top-0 bottom-0"
        v-if="loading"
      >
        <LoadingSpinner class="h-7 w-7 text-yellow-500" />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-2 mt-4">
      <OrderTypeChart :day="selectedDay" :month="selectedMonth" />

      <LocationTypeChart :day="selectedDay" :month="selectedMonth" />
    </div>

    <div class="grid grid-cols-1 gap-2 mt-4">
      <FoodTypeChart2 :day="selectedDay" :month="selectedMonth" />
    </div>
    <FoodTreemap :day="selectedDay" :month="selectedMonth" />
  </div>
</template>

<script>
import DayViewer from "../../components/Management/DayViewer";
import {
  CashIcon,
  FireIcon,
  ReceiptTaxIcon,
  UsersIcon,
} from "@heroicons/vue/outline";
import OrderTypeChart from "../../components/Management/OrderTypeChart";
import jDate from "jalali-date";
import LocationTypeChart from "../../components/Management/LocationTypeChart";
import { getSummeryData, getHallUserCount } from "../../API/API";
import FoodTreemap from "../../components/Management/FoodTreemap";
import LoadingSpinner from "../../components/General/LoadingSpinner";
import MonthViewer from "../../components/Management/MonthViewer";
import FoodTypeChart2 from "../../components/Management/FoodTypeChart2.vue";

export default {
  name: "Analytics",
  components: {
    MonthViewer,
    LoadingSpinner,
    FoodTreemap,
    LocationTypeChart,
    OrderTypeChart,
    DayViewer,
    CashIcon,
    UsersIcon,
    ReceiptTaxIcon,
    FireIcon,
    FoodTypeChart2,
  },
  data() {
    return {
      selectedDay: new jDate().getDate(),
      selectedMonth: new jDate().getMonth(),
      daysInMonth: "",
      summaryData: {},
      loading: true,
      countSalon:0

    };
  },
  created() {
    this.getDaysInMonth();
    this.getSummery();
    this.getHallUserCount();
    console.log(this.countSalon)
  },
  methods: {
    async getSummery() {
      this.loading = true;
      this.summaryData = (
        await getSummeryData("day", "", this.selectedMonth, this.selectedDay)
      ).data.result;
      this.loading = false;
    },
    getDaysInMonth() {
      let today = new jDate();
      // this.daysInMonth = jDate.daysInMonth(today.getFullYear(), this.selectedMonth)
      if (this.selectedMonth <= 6) {
        this.daysInMonth = 31;
        return;
      }

      if (this.selectedMonth <= 11) {
        this.daysInMonth = 30;
        return;
      }

      if (jDate.isLeapYear(today.getFullYear())) {
        this.daysInMonth = 30;
        return;
      }

      this.daysInMonth = 29;
      return;
    },
    async getHallUserCount() {
      this.loading = true;
      this.countSalon = (
        await getHallUserCount('day', '', this.selectedMonth, this.selectedDay)
      ).data.result.yaxis[0].data[0];
      this.loading = false;
    },
  },
  watch: {
    selectedDay() {
      if (this.selectedDay !== "") {
        this.getSummery();
        this.getHallUserCount();
      }
    },
    selectedMonth() {
      this.getDaysInMonth();
      this.getSummery();
      this.getHallUserCount();
    },
  },
};
</script>

<style scoped></style>
